import { render, staticRenderFns } from "./TypeWellButton.vue?vue&type=template&id=552c2623&scoped=true"
import script from "./TypeWellButton.vue?vue&type=script&lang=ts"
export * from "./TypeWellButton.vue?vue&type=script&lang=ts"
import style0 from "./TypeWellButton.vue?vue&type=style&index=0&id=552c2623&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "552c2623",
  null
  
)

export default component.exports